@if (name && !customLabel) {
  @switch (name | lowercase) {
    @case (status.Ok) {
      <div class="pill ok">{{ 'ok' | translate | uppercase }}</div>
    }
    @case (status.Active) {
      <div class="pill ok">
        {{ (module === mainModulesEnum.Tenant ? 'operational' : 'ok') | translate | uppercase }}
      </div>
    }
    @case (status.NotCompleted) {
      <div class="pill paused">{{ 'notCompleted' | translate | uppercase }}</div>
    }
    @case (status.Paused) {
      <div class="pill paused">{{ 'paused' | translate | uppercase }}</div>
    }
    @case (status.ConfirmationNeeded) {
      <div class="pill paused">{{ 'paused' | translate | uppercase }}</div>
    }
    @case (status.Inactive) {
      <div class="pill archive">{{ 'inactive' | translate | uppercase }}</div>
    }
    @case (status.Archived) {
      <div class="pill archive">{{ 'archive' | translate | uppercase }}</div>
    }
    @case (status.Implementing) {
      <div class="pill implementing">{{ 'implementing' | translate | uppercase }}</div>
    }
    @case (status.InProgress) {
      <div class="pill implementing">{{ 'inProgress' | translate | titlecase }}</div>
    }
    @case (status.Expiring) {
      <div class="pill expiring">{{ 'expiring' | translate | titlecase }}</div>
    }
    @case (status.Expired) {
      <div class="pill expired">{{ 'expired' | translate | titlecase }}</div>
    }
    <!-- Storage status start -->
    @case (status.UnderThreshold) {
      <div class="pill expiring">{{ 'underThreshold' | translate | titlecase }}</div>
    }
    @case (status.UnderMinimum) {
      <div class="pill expired">{{ 'underMinimum' | translate | titlecase }}</div>
    }
    @case (status.ProductInOrder) {
      <div class="pill implementing">{{ 'productInOrder' | translate | titlecase }}</div>
    }
    <!-- Storage status end -->
    <!-- Document status  -->
    @case (status.Published) {
      <div class="pill ok">{{ 'ok' | translate | uppercase }}</div>
    }
    @case (status.Draft) {
      <div class="pill implementing">{{ 'draft' | translate | titlecase }}</div>
    }
    @case (status.NotStarted) {
      <div class="pill paused">{{ 'notStarted' | translate | titlecase }}</div>
    }
    @case (status.UnderRevision) {
      <div class="pill paused">{{ 'underRevision' | translate | titlecase }}</div>
    }
    @case (status.ForApproval) {
      <div class="pill ok">{{ 'forApproval' | translate | titlecase }}</div>
    }
    @case (status.InactiveOrHistory) {
      <div class="pill archive">{{ 'inactiveOrHistory' | translate | titlecase }}</div>
    }
    @case (status.Rejected) {
      <div class="pill rejected">{{ 'rejected' | translate | titlecase }}</div>
    }
    @case (status.Disabled) {
      <div class="pill disabled">{{ 'disabled' | translate | titlecase }}</div>
    }
    @case (status.Deactivated) {
      <div class="pill disabled">{{ 'deactivated' | translate | titlecase }}</div>
    }
    @case (status.Deleted) {
      <div class="pill deleted">{{ 'deleted' | translate | titlecase }}</div>
    }
    @case (status.Breached) {
      <div class="pill breached">{{ 'breached' | translate | titlecase }}</div>
    }
    @case (status.AdminSigned) {
      <div class="pill paused">{{ 'adminSigned' | translate | titlecase }}</div>
    }
    @case (status.NotSigned) {
      <div class="pill disabled">{{ 'notSigned' | translate | titlecase }}</div>
    }
    @case (status.Reopened) {
      <div class="pill reopened">{{ 'reopened' | translate | titlecase }}</div>
    }
    @case (status.Pending) {
      <div class="pill paused">{{ 'pending' | translate | titlecase }}</div>
    }
    @case (status.Approved) {
      <div class="pill ok">{{ 'approved' | translate | titlecase }}</div>
    }
    @case (status.Completed) {
      <div class="pill ok">{{ 'completed' | translate | titlecase }}</div>
    }
    @case (status.Exported) {
      <div class="pill implementing">{{ 'exported' | translate | titlecase }}</div>
    }
    @case (status.Outdated) {
      <div class="pill archive">{{ 'outdated' | translate | titlecase }}</div>
    }
    @case (status.Closed) {
      <div class="pill archive">{{ 'closed' | translate | titlecase }}</div>
    }
  }
}
@if (customLabel) {
  <div class="pill" [ngClass]="name"><ng-content></ng-content></div>
}

@if (number) {
  <div
    class="pill due-list-summary"
    [ngClass]="expiredDueListWarnings ? 'due-list-expired' : 'due-list-expiring'"
  >
    {{ number }}
  </div>
}
